export default __webpack_public_path__ + "static/media/Archdeacon's Boots of the Spilling Blood.cddf577a.jpg";